import React from 'react';
import { Button, ButtonColor } from '@lux/buttons';
import { Size } from '@lux/dialog';
import { ControlsCloseS, PlusBadgeIcon2 } from '@lux/icons';
import { Preset, Text } from '@lux/text';
import { Title, TitlePreset, Tag } from '@lux/title';
import { FunctionColor } from '@lux/tokens';
import { UrlSource, useConfig } from '@browsing/config';
import { getCookie } from '@browsing/utils';
import { tracker } from '../../tracking';
import { setEducationalLocationInSessionStorage } from '../../utils';
import { Benefit } from './benefit';
import * as S from './styles-v2';
import { BackgroundDesktop } from '../../utils/images/education-background-desktop';
import { BackgroundMobile } from '../../utils/images/education-background-mobile';
export var EducationalDialogV2 = function (_a) {
    var benefits = _a.benefits, context = _a.context, cta = _a.cta, description = _a.description, footer = _a.footer, isShown = _a.isShown, onClose = _a.onClose, title = _a.title, isMobileScreen = _a.isMobileScreen;
    var config = useConfig();
    var baseUrl = config.getUrl(UrlSource.BASE);
    var successUrl = encodeURIComponent("".concat(baseUrl, "plus-membership/signup/success"));
    var errorUrl = encodeURIComponent(baseUrl);
    var ctaLink = "".concat(cta === null || cta === void 0 ? void 0 : cta.targetAction, "?context=").concat(context, "&zetsr=").concat(successUrl, "&zetner=").concat(errorUrl);
    var onCTAClick = function () {
        tracker.track('plus_educationStep_beginSignUpPlus', { lastPlusCTA: context });
        setEducationalLocationInSessionStorage();
    };
    var handleSwipe = function () {
        // TODO: Remove getCookie('sgtm') === 'true' after getting confirmation from GA4 team
        if (getCookie('sgtm') === 'true' || config.isEnabled('ga4')) {
            var payload = {
                event_name: 'swipe_plus_signup',
                swipe_plus_signup: {
                    element: 'plus_signup',
                },
            };
            tracker.track('GA4-swipe_plus_signup', payload);
        }
        tracker.track('plus_educationStep_swipe');
    };
    return (React.createElement(S.Dialog, { closeDialog: onClose, isShown: isShown, size: Size.S, sizeSm: Size.L, rawDialogBody: true },
        React.createElement(S.Background, null, isMobileScreen ? (React.createElement(BackgroundMobile, { height: "100%", width: "100%" })) : (React.createElement(BackgroundDesktop, { height: "100%", width: "100%" }))),
        React.createElement(S.ContentWrapper, null,
            React.createElement(S.Header, null,
                React.createElement(S.CloseWrapper, null,
                    React.createElement(S.LogoWrapper, null,
                        React.createElement(PlusBadgeIcon2, { color: FunctionColor.function0 }),
                        React.createElement(S.DialogTitle, { preset: TitlePreset.XS, color: FunctionColor.function0, tag: Tag.SPAN }, 
                        /**
                         * TODO: what is the business logic here to show first benefit title?
                         */
                        benefits && benefits.length > 0 && benefits[0].title)),
                    React.createElement("button", { onClick: onClose, onKeyPress: onClose, tabIndex: -1, type: "button" },
                        React.createElement(ControlsCloseS, { "aria-hidden": "true", color: FunctionColor.function0 }))),
                React.createElement(Title, { preset: TitlePreset.S, presetSm: TitlePreset.M, presetLg: TitlePreset.L }, title)),
            React.createElement(S.CarouselWrapper, null,
                React.createElement(S.Carousel, { onScroll: handleSwipe, visibleItems: 1, visibleItemsXs: 3, visibleItemsSm: 4 }, benefits.map(function (_a, index) {
                    var availability = _a.availability, benefitDescription = _a.description, primaryImage = _a.primaryImage, subtitle = _a.subtitle, benefitTitle = _a.title;
                    return (React.createElement(Benefit, { key: benefitTitle + index, availability: availability, description: benefitDescription, image: primaryImage === null || primaryImage === void 0 ? void 0 : primaryImage.uri, subtitle: subtitle, title: benefitTitle }));
                })))),
        React.createElement(S.Footer, null,
            React.createElement("div", null,
                React.createElement(Text, { color: FunctionColor.function0, preset: Preset.S },
                    React.createElement("span", { dangerouslySetInnerHTML: { __html: description } })),
                React.createElement(Button, { disabled: (cta === null || cta === void 0 ? void 0 : cta.isDisabled) === 'true', fullWidth: true, href: ctaLink, link: true, onClick: onCTAClick, color: ButtonColor.bright }, cta === null || cta === void 0 ? void 0 : cta.text),
                React.createElement(Text, { color: FunctionColor.function0, preset: Preset.S },
                    React.createElement("span", { dangerouslySetInnerHTML: { __html: footer } }))))));
};
